"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

require("./Navigation.css");

var CategoryVerticalMenu = function CategoryVerticalMenu(_ref) {
  var categories = _ref.categories;
  return _react["default"].createElement(_semanticUiReact.Menu, {
    vertical: true
  }, _react["default"].createElement(_semanticUiReact.Menu.Item, {
    header: true
  }, "Categories"), categories.map(function (_ref2) {
    var name = _ref2.name;
    return _react["default"].createElement(_semanticUiReact.Menu.Item, null, name);
  }));
};

var _default = CategoryVerticalMenu;
exports["default"] = _default;